import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Moon, Frown, HeartCrack } from 'lucide-react';
export function EmotionalHook() {
  return <section className="py-16 px-4 bg-cream-100" data-id="element-36">
      <div className="max-w-3xl mx-auto" data-id="element-37">
        <FadeIn data-id="element-38">
          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-cream-200 relative" data-id="element-39">
            <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-terracotta text-white p-3 rounded-full shadow-md" data-id="element-40">
              <Moon className="w-6 h-6" data-id="element-41" />
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 mt-4" data-id="element-42">
              La escena que se repite cada noche...
            </h2>

            <div className="space-y-6 text-lg md:text-xl text-warmBrown-800 leading-relaxed" data-id="element-43">
              <p data-id="element-44">
                Llegas a casa después de un día agotador. Lo único que pides es
                una cena tranquila y que los niños se pongan la pijama.
              </p>

              <p data-id="element-45">
                Pero en lugar de eso, hay gritos, comida en el suelo y una
                desobediencia que te hace hervir la sangre. Sientes ese calor
                subiendo por tu pecho. Intentas respirar, pero explotas.
              </p>

              <div className="flex items-start gap-4 p-6 bg-coral-50 rounded-2xl border border-coral-100" data-id="element-46">
                <Frown className="w-8 h-8 text-coral shrink-0 mt-1" data-id="element-47" />
                <p className="text-coral-900 font-medium" data-id="element-48">
                  Gritas tan fuerte que tu propia garganta duele. El silencio
                  que sigue es peor: tus hijos te miran con miedo y tú te quedas
                  con una culpa que no te deja dormir.
                </p>
              </div>

              <div className="flex items-center gap-3 justify-center pt-4" data-id="element-49">
                <HeartCrack className="w-6 h-6 text-terracotta-400" data-id="element-50" />
                <p className="italic text-center text-terracotta-700 font-heading text-2xl" data-id="element-51">
                  "No quiero ser esta clase de madre", te dices.
                </p>
                <HeartCrack className="w-6 h-6 text-terracotta-400" data-id="element-52" />
              </div>

              <p className="text-center font-semibold pt-4" data-id="element-53">
                Pero mañana, el ciclo se repite.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}